// $(document).ready(function() {
//     var inventoryData = JSON.parse($('#product-variant-inventory').html());
  
//     function updateStockMessage(optionValue) {
//       var variant = inventoryData.variants.find(function(v) {
//         return v.option1 === optionValue;
//       });

//       console.log('variant',variant);
  
//       if (variant && variant.inventory_quantity > 0 && variant.inventory_quantity < 10) {
//         $('#low-stock-message').text('נותרו רק ' + variant.inventory_quantity + ' במלאי!');
//       } else {
//         $('#low-stock-message').text('');
//       }
//     }
  
//     // On load, show for selected option
//     var selectedRadio = $('input[type="radio"][name^="midot carpet dropdown-1"]:checked');
//     if (selectedRadio.length > 0) {
//       updateStockMessage(selectedRadio.val());
//     }
  
//     // On change
//     $(document).on('change', 'input[type="radio"][name^="midot carpet dropdown-1"]', function() {
//       updateStockMessage($(this).val());
//     });
//   });

var CgProduct = {

    init: function()
    {

        var me = this;
        me.initTabs();
        me.initSimulation();
        me.initLowStockMessage();
        // me.initSliderArrows();

    },


    initTabs: function()
    {

        var to = null;

        $(".cg-product-tabs .tab-link").on("click", function(e){

            e.preventDefault();
            clearTimeout(to);
            var elem = $(this);
            var target = $(".tab-wrap " + elem.attr("href"));

            if(elem.hasClass("active")){
                elem.removeClass("active");
                target.removeClass("active");
                target.removeClass("animated");
            }else{
                elem.addClass("active");
                target.addClass("active");
                to = setTimeout(function(){
                    target.addClass("animated");
                }, 800);
            }

        });

    },

    initLowStockMessage: function(){
        var me = this;
        var inventoryData = JSON.parse($('#product-variant-inventory').html());
        var selectedRadio = $('input[type="radio"][name^="midot carpet dropdown-1"]:checked');
        if (selectedRadio.length > 0) {
            me.updateStockMessage(selectedRadio.val(), inventoryData);
        }

        $(document).on('change', 'input[type="radio"][name^="midot carpet dropdown-1"]', function(e) {
            me.updateStockMessage($(this).val(), inventoryData);
        });

    },

    updateStockMessage: function(optionValue, inventoryData) {
        $(".cg-estimated-delivery").show();
        var variant = inventoryData.variants.find(function(v) {
            return v.option1 === optionValue;
        });
    
        if (variant && variant.inventory_quantity > 0 && variant.inventory_quantity < 10) {
            $('#low-stock-message').text('מהרו, נותרו רק ' + variant.inventory_quantity + ' במלאי!');
        } else {
            $('#low-stock-message').text('');
        }

        if(variant.inventory_quantity == 0) {
            $(".cg-estimated-delivery").hide();
        }

        if(variant.sku) {
            $(".cg-estimated-delivery .sku-wrap").html(`מק"ט: ${variant.sku}`);
        }
        

    },


    initSimulation: function()
    {

        var defaultURL = 'https://carmelfloor.floori.io/';
        var selectedVariant = $("[data-simulation-sku].selected");

        if(selectedVariant.length) {

            var prod_sku = selectedVariant.attr("data-simulation-sku");
            var newUrl = defaultURL;

            if(prod_sku) {
                newUrl = newUrl + "?sku=" + selectedVariant.attr("data-simulation-sku");
            }
            
            $(".product .simulation-btn").attr("data-simulation", newUrl);

        }else{
            $(".product .simulation-btn").attr("data-simulation", defaultURL);
        }

        $(document).on("click", ".product__info-container .variant-selector label", function(){
            var elem = $(this);
            var prod_sku = elem.attr("data-simulation-sku");
            if(prod_sku) {
                var newUrl = defaultURL + "?sku=" + selectedVariant.attr("data-simulation-sku");
                $(".simulation-btn").attr("data-simulation", newUrl).addClass("has-value");
            }else{
                $(".simulation-btn").attr("data-simulation", defaultURL).removeClass("has-value");
            }
        });

        $(document).on("click", ".product .simulation-btn", function(){
            var rugviewURL = $(this).attr("data-simulation");
            if(rugviewURL) {
                var frame = $(".rugview-frame");
                frame.attr("src", rugviewURL);
                $(".rugview-frame-wrap").addClass("active");
            }
        });

        $(".rugview-frame-wrap .close-btn").on("click", function(){
            $(".rugview-frame-wrap").removeClass("active");
        });

    }

    // initSimulation: function()
    // {

    //     var defaultURL = 'https://carmelfloor.floori.io/';

    //     var selectedVariant = $("[data-rugview-url].selected");
    //     if(selectedVariant.length) {
    //         var rugviewURL = selectedVariant.attr("data-rugview-url") ? selectedVariant.attr("data-rugview-url") : defaultURL;
    //         $(".product .simulation-btn").attr("data-simulation", rugviewURL);
    //     }else{
    //         $(".product .simulation-btn").attr("data-simulation", defaultURL);
    //     }

    //     $(document).on("click", ".product__info-container .variant-selector label", function(){
    //         var elem = $(this);
    //         var rugviewURL = $(this).attr("data-rugview-url");
    //         if(rugviewURL) {
    //             $(".simulation-btn").attr("data-simulation", rugviewURL).addClass("has-value");
    //         }else{
    //             $(".simulation-btn").attr("data-simulation", defaultURL).removeClass("has-value");
    //         }
    //     });

    //     $(document).on("click", ".product .simulation-btn", function(){
    //         var rugviewURL = $(this).attr("data-simulation");
    //         if(rugviewURL) {
    //             var frame = $(".rugview-frame");
    //             frame.attr("src", rugviewURL);
    //             $(".rugview-frame-wrap").addClass("active");
    //         }
    //     });

    //     $(".rugview-frame-wrap .close-btn").on("click", function(){
    //         $(".rugview-frame-wrap").removeClass("active");
    //     });

    // }


    // initSliderArrows: function(){
    //     var currentIndex = 0;
    //     var images = $(".slider-mobile-gutter:not(.thumbnail-slider) .product__media-item");
    //     var totalImages = images.length;

    //     $(".slider-mobile-gutter:not(.thumbnail-slider) .slider-button.slider-button--prev").on("click", function(){
    //         changeImage(-1);
    //     });

    //     $(".slider-mobile-gutter:not(.thumbnail-slider) .slider-button.slider-button--next").on("click", function(){
    //         changeImage(1);
    //     });

    //     function changeImage(delta) {
    //         currentIndex += delta;
    //         if (currentIndex < 0) {
    //           currentIndex = totalImages - 1;
    //         } else if (currentIndex >= totalImages) {
    //           currentIndex = 0;
    //         }
    //         showImage(currentIndex);
    //       }
        
    //       function showImage(index) {
    //         $(".slider-mobile-gutter:not(.thumbnail-slider) .product__media-item.is-active").removeClass("is-active");
    //         $(images[index]).removeClass('scroll-trigger--offscreen').addClass("is-active");
    //         $(".slider-mobile-gutter .thumbnail[aria-current]").removeAttr('aria-current');
    //         var thumbTarget = $(images[index]).attr("data-media-id");
    //         $(`[data-target="${thumbTarget}"] .thumbnail `).attr("aria-current", true);
            
    //         console.log('images[index]',images[index], images);
            
    //       }

    // },


};

$(document).ready(function(){
    CgProduct.init();
});